<script>
    import Vue from 'vue'
    import axios from 'axios';
    
    export default {
        install(Vue, options) {
            var apiDomain = options.apiDomain;
            var region = options.region;
            var store = options.store;

            Vue.prototype.$beneficiaryService = {
                /*
                * Get beneficiaries from API using custom query params
                */
                async searchWithParams(params) {
                    if (params) {
                        params.region = options.region;
                    }                    
                    
                    return await axios.get(apiDomain + '/v1/beneficiaries/search',{ params: params });
                },

                /*
                * Get beneficiaries from API for a specific event
                */
                async searchByEvent(eventCampaignId) {
                    return await this.searchWithParams({
                        eventcampaignid: eventCampaignId
                    });
                },

                /*
                * Get beneficiary details for event
                */
                async getBeneficiaryDetailsForEvent(beneficiaryId, eventCampaignId) {
                    return await this.searchWithParams({
                        eventcampaignid: eventCampaignId,
                        beneficiaryid: beneficiaryId
                    });
                },

                /*
                * Get beneficiary details by Id
                */
                async getBeneficiaryById(beneficiaryId) {
                    return await this.searchWithParams({
                        beneficiaryid: beneficiaryId
                    });
                }
            }
        }
    }
</script>